import Iframe from "components/iframe";
import { useConstants } from "features/constantsProvider/context";
import { _ } from "i18n";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useToast } from "ui-kit";

const PASSWORD_RESET_SUCCESS_EVENT = "passwordResetSuccess";

function isApiOrigin(origin: string, apiURL: string): boolean {
	const apiUrlHttps = apiURL.replace("http://", "https://");
	const apiUrlHttp = apiURL.replace("https://", "http://");

	return origin === apiURL || origin === apiUrlHttps || origin === apiUrlHttp;
}

function isPasswordResetSuccessMessage(data: unknown): boolean {
	if (typeof data !== "object" || data === null) {
		return false;
	}

	if (("event" in data) === false) {
		return false;
	}

	return data.event === PASSWORD_RESET_SUCCESS_EVENT;
}

export default function AmateurClubPasswordResetIframePage() {
	const location = useLocation();
	const { apiURL } = useConstants();
	const { addSuccessToast } = useToast();
	const hasShownSuccessToast = useRef(false);

	useEffect(() => {
		const handleIframeMessage = (event: MessageEvent<unknown>) => {
			if (isApiOrigin(event.origin, apiURL) === false) {
				return;
			}

			if (isPasswordResetSuccessMessage(event.data) === false) {
				return;
			}

			if (hasShownSuccessToast.current) {
				return;
			}

			hasShownSuccessToast.current = true;
			addSuccessToast(_("message.request_password.success.msg"));
		};

		window.addEventListener("message", handleIframeMessage);

		return () => {
			window.removeEventListener("message", handleIframeMessage);
		};
	}, [addSuccessToast, apiURL]);

	const iframeUrl = location.search === "" ? location.pathname : `${location.pathname}${location.search}`;

	return <Iframe url={iframeUrl} />;
}
